import { useEffect, useState } from 'react'

import { VariableValue } from '@components/Variables/types'

import { useFetchAllVariablesQuery } from '@redux/api/variables.api'

import { ENTITY_TYPES_REQUEST } from '@constants'

type useVariablesProps = {
  isEditEntity: boolean
  entityType: ENTITY_TYPES_REQUEST
  entityId?: number | string
}

export const useVariables = ({ isEditEntity, entityType, entityId }: useVariablesProps) => {
  const [currentVariables, setCurrentVariables] = useState<VariableValue[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [isCreateOrEdit, setCreateOrEdit] = useState<boolean>(false)

  const handleCreateOrEdit = (value: boolean) => setCreateOrEdit(value)

  const { data: variablesData } = useFetchAllVariablesQuery(
    {
      viewType: entityType || undefined,
      id: entityId || undefined,
    },
    { skip: !isEditEntity || !entityId, refetchOnMountOrArgChange: true }
  )

  useEffect(() => {
    if (variablesData) {
      setCurrentVariables(variablesData)
      setIsLoading(false)
    }
  }, [variablesData, entityId])

  return {
    currentVariables,
    isLoading,
    handleCreateOrEdit,
    isCreateOrEdit,
  }
}
